var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSuccessCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33307 9.13177L13.1997 1.2651C13.4442 1.02066 13.7553 0.898438 14.1331 0.898438C14.5109 0.898438 14.822 1.02066 15.0664 1.2651C15.3109 1.50955 15.4331 1.82066 15.4331 2.19844C15.4331 2.57621 15.3109 2.88733 15.0664 3.13177L6.26641 11.9318C5.99974 12.1984 5.68863 12.3318 5.33307 12.3318C4.97752 12.3318 4.66641 12.1984 4.39974 11.9318L0.933072 8.4651C0.688628 8.22066 0.566406 7.90955 0.566406 7.53177C0.566406 7.15399 0.688628 6.84288 0.933072 6.59844C1.17752 6.35399 1.48863 6.23177 1.86641 6.23177C2.24418 6.23177 2.5553 6.35399 2.79974 6.59844L5.33307 9.13177Z",
    fill: "#6BE261"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.bb9773d4ec28ca192ae370311e4a0cd4.svg";
export { ForwardRef as ReactComponent };